module.exports = __webpack_public_path__ + "static/media/product-domain.e1161a63.png";